export const defaultAnalyticsData = {
  resourceAnalytics: {
    downloadsByResource: [{ timestamp: new Date(), value: 0 }],
    downloadsByCategory: [{ category: 'No Data', downloads: 0, percentage: 0 }],
    viewTimeByResource: [{ resourceId: 'none', viewTime: 0 }],
    searchTerms: [],
    resourceEngagement: [{ title: 'No Downloads Yet', downloads: 0 }],
    categoryViews: [{ category: 'No Views', views: 0 }]
  },
  applicationAnalytics: {
    applicationSubmissions: [{ timestamp: new Date(), value: 0 }],
    applicationsByType: [
      { category: 'Nonprofit', count: 0, percentage: 0 },
      { category: 'Individual', count: 0, percentage: 0 },
      { category: 'Foundation', count: 0, percentage: 0 }
    ],
    completionRates: {
      started: 0,
      inProgress: 0,
      completed: 0,
      abandoned: 0
    },
    averageCompletionTime: '0m',
    commonDropoffPoints: []
  },
  academyAnalytics: {
    resourceDownloads: [{ timestamp: new Date(), value: 0 }],
    popularResources: [],
    resourcesByCategory: [
      { category: 'Fiscal Sponsorship', downloads: 0, percentage: 0 },
      { category: 'Compliance', downloads: 0, percentage: 0 },
      { category: 'Operations', downloads: 0, percentage: 0 },
      { category: 'Fundraising', downloads: 0, percentage: 0 }
    ],
    readingStats: {
      averageReadTime: '0m',
      completionRate: '0%',
      totalDownloads: 0
    }
  },
  donationAnalytics: {
    donationTrends: [{ timestamp: new Date(), value: 0 }],
    donationsByType: [
      { type: 'One-time', amount: 0, percentage: 0 },
      { type: 'Monthly', amount: 0, percentage: 0 },
      { type: 'Annual', amount: 0, percentage: 0 }
    ],
    donorRetention: {
      newDonors: 0,
      returningDonors: 0,
      retentionRate: '0%'
    },
    averageDonation: '$0',
    totalDonations: '$0',
    donorGrowth: 0
  }
}; 